module.exports = __webpack_public_path__ + "static/images/optimize-route.25eHGHC.svg";